import { render, staticRenderFns } from "./MessageModalSection.vue?vue&type=template&id=f1829b2a&scoped=true"
import script from "./MessageModalSection.vue?vue&type=script&lang=ts"
export * from "./MessageModalSection.vue?vue&type=script&lang=ts"
import style0 from "./MessageModalSection.vue?vue&type=style&index=0&id=f1829b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1829b2a",
  null
  
)

export default component.exports